import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import PdpIcon from './product/pdpIcon';

// Visible breadcrumb trail. Pair with ScriptMarkupBreadcrumb on the same
// items. The last item is the current page and is not a link.
const Breadcrumb = ({ items }) => (
  <nav aria-label="Breadcrumb" className="breadcrumb-nav">
    <ol>
      {items.map((item, index) =>
        index === items.length - 1 ? (
          <li key={item.name} aria-current="page">
            {item.name}
          </li>
        ) : (
          <li key={item.name}>
            <Link href={item.url}>{item.name}</Link>
            <PdpIcon name="chevronRight" size={12} />
          </li>
        ),
      )}
    </ol>
  </nav>
);

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default Breadcrumb;
